import { UPDATE_PAYMENT_INFO } from "@app/modules/checkout/constants/action-types";
import type { UpdatePaymentInfoAction } from "@app/modules/checkout/types/checkout-actions-types";
import type { PaymentInfo } from "@app/types/checkout-form-types";

export function updatePaymentInfo(
  payment_info: PaymentInfo
): UpdatePaymentInfoAction {
  return {
    type: UPDATE_PAYMENT_INFO,
    payment_info
  };
}
